window.footerV3Submit = async (form) => {
  const button = form.querySelector('[type="submit"]');
  if (button.disabled) return;
  const input = form.querySelector('input[type="email"]');
  const message = form.querySelector('[data-footer-v3-message]');
  button.disabled = true;
  message.hidden = true;
  input.removeAttribute('aria-invalid');
  input.removeAttribute('aria-describedby');

  try {
    const response = await fetch(form.action, { method: 'POST', body: new FormData(form) });
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const returnedForm = form.id ? page.getElementById(form.id) : page.querySelector('.footer-v3__form');
    const result = returnedForm?.querySelector('[data-footer-v3-message]');
    const confirmed = response.ok && result && !result.hidden && result.textContent.trim();
    const error = confirmed && result.classList.contains('footer-v3__message--error');
    const success = confirmed && !error;

    message.textContent = confirmed ? result.textContent.trim() : message.dataset.error;
    message.classList.toggle('footer-v3__message--error', !success);
    message.setAttribute('role', success ? 'status' : 'alert');
    if (success) {
      input.value = '';
      if (!window.Shopify?.designMode && !form.closest('[data-design-mode]')) {
        try { localStorage.setItem('nervape-newsletter-subscribed', '1'); } catch { /* Storage may be blocked. */ }
      }
      form.dispatchEvent(new CustomEvent('newsletter:success', { bubbles: true }));
    }
    if (error) {
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', message.id);
    }
  } catch {
    message.textContent = message.dataset.error;
    message.classList.add('footer-v3__message--error');
    message.setAttribute('role', 'alert');
  } finally {
    message.hidden = false;
    button.disabled = false;
  }
};

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.footer-v3__form, [data-newsletter-form]')) return;
  event.preventDefault();
  if (!form.hasAttribute('data-hcaptcha-bound')) window.footerV3Submit(form);
});
